module.exports = __webpack_public_path__ + "img/logonew_bottom_en.dfaacecf.png";